import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cooking-conversion-calculator',
  component: () => import('../../routes/CookingConversionCalculator.svelte'),
  card: {
    id: 'cooking-conversion-calculator',
    title: 'Cooking Conversion Calculator',
    description: 'Convert between cups, grams, ounces, tablespoons, and more for accurate recipe measurements.',
    icon: 'restaurant',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/cooking-conversion-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Cooking Conversion Calculator – Cups, Grams, Ounces & More',
    description: 'Free cooking conversion calculator. Convert between volume (cups, tbsp, ml), weight (grams, oz, lb), and temperature (°F, °C, K) for accurate recipe measurements.',
  },
};

export default meta;